import client from '@/services/';

const state = () => ({
    all: [],
    allWithoutAdmin: {},
    dash: [],
    allRegions: [],
    one: {}
});

const getters = {
    all: state => state.all,
    allWithoutAdmin: state => state.allWithoutAdmin,
    dash: state => state.dash,
    allRegions: state => state.allRegions,
    one: state => state.one
};

const mutations = {
    SET_ALL_REGIONS: (state, obj) => {
        state.allRegions = obj;
    },
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ALL_WITHOUT_ADMIN: (state, obj) => {
        state.allWithoutAdmin = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    },
    SET_DASH: (state, obj) => {
        state.dash = obj;
    },
};

const actions = {
    async getAll(cxt, payload) {
        let { data } = await client.get('user/all');
        cxt.commit("SET_ALL", data);
        return data;
    },
    async getAllP({ commit }, params = {}) {
        const { page = 0, size = 10, sort = '', role, nom, prenoms, username, contact, email, matricule } = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
            ...(role && { role }),
            ...(nom && { nom }),
            ...(prenoms && { prenoms }),
            ...(username && { username }),
            ...(contact && { contact }),
            ...(email && { email }),
            ...(matricule && { matricule }),
        }).toString();
        let { data } = await client.get(`user/admin-comite-only?${queryParams}`);
        commit("SET_ALL", data)
        return data;
    },
    async getAllPWithoutAdmin({ commit }, params = {}) {
        const { page = 0, size = 10, sort = '', role, nom, prenoms, username, contact, email, matricule, statutMaintien, sousCode, sousLibelle, expertsOnly } = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
            ...(role && { role }),
            ...(nom && { nom }),
            ...(prenoms && { prenoms }),
            ...(username && { username }),
            ...(contact && { contact }),
            ...(email && { email }),
            ...(matricule && { matricule }),
            ...(statutMaintien && { statutMaintien }),
            ...(sousCode && { sousCode }),
            ...(sousLibelle && { sousLibelle }),
            ...(expertsOnly && { expertsOnly: true }),
        }).toString();
        let { data } = await client.get(`user/without-comite-admin?${queryParams}`);
        commit("SET_ALL_WITHOUT_ADMIN", data)
        return data;
    },
    async create(cxt, payload) {
        let { data } = payload.id ? await client.put('user/edit/' + payload.id, payload) : await client.post('user/add', payload);
        cxt.commit("SET_ONE", data);
        if (payload.id) {
            payload.id = null;
        }
        return data;
    },
    async update(cxt, payload) {
        let { data } = await client.put('user/edit/' + payload.id, payload)
        //cxt.commit("SET_ONE", data);
        return data;
    },
    async createSignataire(cxt, payload) {
        let { data } = await client.post('/signataires/define', payload);
        return data;
    },
    async getAllSignataire({ commit }, params = {}) {
        const { page = 0, size = 10, sort = '' } = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
        }).toString();
        let { data } = await client.get(`signataires?${queryParams}`);
        commit("SET_DASH", data)
        return data;
    },
    async searchUser(cxt, numero) {
        let { data } = await client.get(`/user/details/${numero}`)
        return data;
    },
    async getUserIsExpert(cxt, libelle) {
        let { data } = await client.get(`/user/role/${libelle}`)
        return data;
    },
    async getAllStagiaireToExpert(cxt, id) {
        let  data  = await client.get(`/user/${id}/stagiaires`);
        return data;
    },
    async getAllSocieteToExpert(cxt, id) {
        let  data  = await client.get(`/user/${id}/societes`);
        return data;
    },
    async getAllCotisationToExpert(cxt, id) {
        let  data  = await client.get(`/user/${id}/cotisations`);
        return data;
    },
    async getUserFichiers(cxt, userId) {
        const { data } = await client.get(`user/${userId}/fichiers`);
        return data;
    },
    async getAllFormation({ commit }, params = {}) {
        const { page = 0, size = 10, sort = '', matricule, aSuivi, after, before } = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
            ...(aSuivi && { aSuivi }),
            ...(after && { after }),
            ...(before && { before }),
        }).toString();
        const { data } = await client.get(`user/formation-participate?${queryParams}`, { params: { matricule } });
        return data;
    },
    async regenererDocument(cxt, userId) {
        const { data } = await client.post(`user/${userId}/regenerer-document`);
        return data;
    },
    async getAllDossier(cxt, email) {
        try {
            const respImport = await client.get('/user/demande-importation', { params: { email } });
            const emptyImport =
                !respImport?.data ||
                (Array.isArray(respImport.data) && respImport.data.length === 0) ||
                (typeof respImport.data === 'object' && Object.keys(respImport.data).length === 0);

            if (!emptyImport) {
                return respImport;
            }
        } catch (e) {
            // Erreur sur importation: on passe au fallback
        }

        const respInscr = await client.get('/user/demande-inscription', { params: { email } });
        return respInscr;
    },
    async exportToExcel() {
        const response = await client.get('user/export/excel', {
            responseType: 'blob'
        });
        return response;
    },
    async exportToExcelWithoutAdmin(_ctx, params = {}) {
        const { role, nom, prenoms, username, contact, email, matricule, statutMaintien, sousCode, sousLibelle, exportCible } = params;
        const queryParams = new URLSearchParams({
            ...(role && { role }),
            ...(nom && { nom }),
            ...(prenoms && { prenoms }),
            ...(username && { username }),
            ...(contact && { contact }),
            ...(email && { email }),
            ...(matricule && { matricule }),
            ...(statutMaintien && { statutMaintien }),
            ...(sousCode && { sousCode }),
            ...(sousLibelle && { sousLibelle }),
            ...(exportCible && { exportCible }),
        }).toString();
        
        const response = await client.get(`user/export/excel/without-comite-admin?${queryParams}`, {
            responseType: 'blob'
        });
        return response;
    },
    async exportToPdfWithoutAdmin(_ctx, params = {}) {
        const { role, nom, prenoms, username, contact, email, matricule, statutMaintien, sousCode, sousLibelle, exportCible } = params;
        const queryParams = new URLSearchParams({
            ...(role && { role }),
            ...(nom && { nom }),
            ...(prenoms && { prenoms }),
            ...(username && { username }),
            ...(contact && { contact }),
            ...(email && { email }),
            ...(matricule && { matricule }),
            ...(statutMaintien && { statutMaintien }),
            ...(sousCode && { sousCode }),
            ...(sousLibelle && { sousLibelle }),
            ...(exportCible && { exportCible }),
        }).toString();
        
        const response = await client.get(`user/export/pdf/without-comite-admin?${queryParams}`, {
            responseType: 'blob'
        });
        return response;
    },
    async verifyMatricule(cxt, matricule) {
        const { data } = await client.get('user/verify-matricule', { params: { matricule } });
        return data;
    },
    async generateCertificatsMaintienAjour(cxt) {
        const { data } = await client.post('user/generate-certificats-maintien-ajour');
        return data;
    },

    async getPublicExperts(cxt, params = {}) {
        const { page = 0, size = 20, query = '', role = '', matricule = '', nom = '', email = '' } = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            ...(query && { query }),
            ...(role && { role }),
            ...(matricule && { matricule }),
            ...(nom && { nom }),
            ...(email && { email }),
        }).toString();
        const { data } = await client.get(`public/experts?${queryParams}`);
        return data;
    },
    async getPublicSocietes(cxt, params = {}) {
        const { page = 0, size = 20, query = '', matricule = '', cabinet = '', email = '' } = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            ...(query && { query }),
            ...(matricule && { matricule }),
            ...(cabinet && { cabinet }),
            ...(email && { email })
        }).toString();
        const { data } = await client.get(`public/societes?${queryParams}`);
        return data;
    },
    async getPublicChiffresCles() {
        const { data } = await client.get('public/chiffres-cles');
        return data;
    },

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
